export default function Testimonial() {
  const testimonials = [
    {
      id: 1,
      name: "Maria Santos",
      role: "Working Professional",
      image: "https://randomuser.me/api/portraits/women/2.jpg",

      review:
        "The place is super clean and quiet. Perfect for remote work! The staff are friendly and the location is very convenient.",
    },
    {
      id: 2,
      name: "James Cruz",
      role: "Student",
      image: "https://randomuser.me/api/portraits/men/6.jpg",
      review:
        "Affordable price and very comfortable rooms. WiFi is fast and stable which is important for my online classes.",
    },
    {
      id: 3,
      name: "Angela Reyes",
      role: "Long-term Tenant",
      image: "https://randomuser.me/api/portraits/women/8.jpg",
      review:
        "I’ve stayed here for over a year and I love it. Safe environment, great amenities, and feels like home.",
    },
  ]

  return (
    <section className="py-20 bg-white" id="testimonials">
      <div className="max-w-7xl mx-auto px-8">
        {/* TITLE */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-slate-900">
            What Our Guests Say
          </h2>
          <p className="text-slate-600 mt-2">
            Real experiences from people who stayed with us.
          </p>
        </div>

        {/* GRID */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8">
          {testimonials.map((guest) => (
            <div
              key={guest.id}
              className="bg-slate-50 rounded-xl p-6 shadow hover:shadow-xl transition"
            >
              {/* PROFILE */}
              <div className="flex items-center gap-4 mb-4">
                <img
                  src={guest.image}
                  alt={guest.name}
                  className="w-14 h-14 rounded-full object-cover"
                />

                <div>
                  <h3 className="font-semibold text-slate-900">{guest.name}</h3>
                  <p className="text-sm text-slate-500">{guest.role}</p>
                </div>
              </div>

              {/* REVIEW */}
              <p className="text-slate-600 text-sm leading-relaxed">
                “{guest.review}”
              </p>

              {/* STARS */}
              <div className="mt-4 text-orange-500 text-lg">★★★★★</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
